// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amr-meter-group {
  width: 25%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.amr-meter-group__gauges {
  display: flex;
  flex-direction: row;
  gap: 1px;
}
.amr-meter-group__legends {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.amr-meter-group__legends__legend {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
}
.amr-meter-group__total {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 0.35rem;
  font-weight: bold;
}
.amr-meter-group__total__value {
  font-size: 1.5rem;
}
.amr-meter-group__total__label {
  color: #818181;
  font-size: 0.85rem;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/amr-meter-group/amr-meter-group.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACJ;AAEI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAAR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAAR;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAAZ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;AADR;AAGQ;EACI,iBAAA;AADZ;AAGQ;EACI,cAAA;EACA,kBAAA;AADZ","sourcesContent":[".amr-meter-group{\n    width: 25%;\n    display: flex;\n    flex-direction: column;\n    gap:0.5rem;\n   \n    \n    &__gauges{\n        display: flex;\n        flex-direction: row;\n        gap: 1px;\n    }\n    &__legends{\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        \n        &__legend{\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 0.5rem;\n            font-size: 0.75rem;\n        }\n    }\n    &__total{\n        display: flex;\n        flex-direction: row;\n        align-items: baseline;\n        gap: 0.35rem;\n        font-weight: bold;\n\n        &__value{\n            font-size: 1.5rem;\n        }\n        &__label{\n            color: #818181;\n            font-size: 0.85rem;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
